import { __ } from "@wordpress/i18n";
import { useSettingsContext } from "../../../hook/useSettingsContext";
import { Menu } from "lucide-react";
import TabNavigation from "./TabNavigation";
import GeneralSettings from "./tabs/GeneralSettings";
import QuantitySettings from "./tabs/QuantitySettings";
import InputSettings from "./tabs/InputSettings";
import SliderSettings from "./tabs/SliderSettings";
import MessagesSettings from "./tabs/MessagesSettings";
import IconSettings from "./tabs/IconSettings";
import PrefixSuffixSettings from "./tabs/PrefixSuffixSettings";
import SaveButton from "../SaveButton";

export default function SettingsPage() {
    const { activeTab, setSidebarOpen } = useSettingsContext();

    //console.log(activeTab);

    const renderContent = () => {
        switch (activeTab) {
            case "general":
                return <GeneralSettings />;

            case "quantity":
                return <QuantitySettings />;

            case "input":
                return <InputSettings />;

            case "icon":
                return <IconSettings />;

            case "slider":
                return <SliderSettings />;

            case "messages":
                return <MessagesSettings />;

            case "prefixsuffix":
                return <PrefixSuffixSettings />;

            default:
                return null;
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 border-b border-gray-200">
            {/* Mobile toggle button */}
            <div class="wpb-mobile-navigation__top wp:hidden">
                <div class="flex relative flex-shrink-0 h-16 z-10 bg-white border-b border-slate-200">
                    <button
                        onClick={() => setSidebarOpen(true)}
                        type="button"
                        id="button-open-settings-navigation-mobile"
                        class="px-4 border-r border-slate-200 text-slate-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
                    >
                        <span class="sr-only">
                            {__(
                                "Open settings navigation",
                                "wpbean-quantity-controls-for-woocommerce",
                            )}
                        </span>
                        <Menu className="w-5 h-5" />
                    </button>
                </div>
            </div>

            <div className="flex">
                {/* Left Sidebar Navigation */}
                <TabNavigation />

                {/* Main Content */}
                <main className="flex-1 relative">
                    <div className="p-8 max-wp:p-4 min-h-screen">
                        <div className="max-w-4xl">{renderContent()}</div>
                    </div>
                    <SaveButton />
                </main>
            </div>
        </div>
    );
}
